var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58461 20.7292C5.10483 20.6156 3.69878 20.0373 2.56723 19.077C1.43569 18.1166 0.636498 16.8233 0.283783 15.3817C-0.0689314 13.9401 0.0428625 12.4239 0.603202 11.0496C1.16354 9.67531 2.14378 8.5132 3.40394 7.7292C3.67208 5.63846 4.69289 3.71708 6.27533 2.32462C7.85778 0.932164 9.89341 0.164062 12.0013 0.164062C14.1091 0.164062 16.1448 0.932164 17.7272 2.32462C19.3097 3.71708 20.3305 5.63846 20.5986 7.7292C21.8588 8.5132 22.839 9.67531 23.3993 11.0496C23.9597 12.4239 24.0715 13.9401 23.7188 15.3817C23.366 16.8233 22.5669 18.1166 21.4353 19.077C20.3038 20.0373 18.8977 20.6156 17.4179 20.7292V20.7498H6.58461V20.7292ZM13.0846 12.0831H16.3346L12.0013 6.66645L7.66794 12.0831H10.9179V16.4165H13.0846V12.0831Z",
    fill: "#8BA4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.26be9046bd3a8c7f7525dd73515b555c.svg";
export { ForwardRef as ReactComponent };